import { useContext } from "react";
import { ButtonDS, GlobalIcon } from "get-life-storybook-ts";
import { I18nContext } from "../../../../../../context/i18n.context";
import { PricingI } from "../../../../../../api/request/Lead/Interfaces/PricingInterface";
import numberFormat from "../../../../../../utils/Utils";
import { priceUpdatingText } from "../pricing/dashboardPrice";
import { cardStyle, sectionTitleStyle, sectionTitleText } from "../cardStyles";

interface BillingCardProps {
  isCancelled: boolean;
  paymentMethodLabel: string;
  frequency: string;
  hasPromo: boolean;
  /** null = sin prima (cohorte SCOR FR): se pinta el texto neutro, nunca un importe. */
  regularPrice: number | null;
  displayPrice: number | null;
  pricing?: PricingI;
  navigateToRoute: (route: string) => void;
  onShowConditions: () => void;
}

const BillingCard = ({
  isCancelled,
  paymentMethodLabel,
  frequency,
  hasPromo,
  regularPrice,
  displayPrice,
  pricing,
  navigateToRoute,
  onShowConditions,
}: BillingCardProps) => {
  const {
    state: { translate, langCode },
  } = useContext(I18nContext);

  return (
    <div style={cardStyle}>
      <div style={sectionTitleStyle}>
        <GlobalIcon iconName="CurrencyEuroIcon" size="XS" color="#4f46e5" />
        <h2 style={sectionTitleText}>
          {translate("newDashboard.redesign.billingAndPayments")}
        </h2>
      </div>

      <div style={{ paddingBottom: 16, borderBottom: "1px solid #f3f4f6", marginBottom: 16 }}>
        <p style={{ fontSize: 13, fontWeight: 500, color: "#6b7280", margin: "0 0 4px" }}>
          {translate("newDashboard.paymentMethod")}
        </p>
        <p style={{ fontSize: 15, fontWeight: 500, color: "#111827", margin: 0 }}>
          {paymentMethodLabel}
        </p>
      </div>

      {!isCancelled && (
        <div style={{ paddingBottom: 16, borderBottom: "1px solid #f3f4f6", marginBottom: 16 }}>
          <p style={{ fontSize: 13, fontWeight: 500, color: "#6b7280", margin: "0 0 4px" }}>
            {translate(
              frequency === "MONTHLY"
                ? "newDashboard.monthlyFee"
                : "newDashboard.yearlyFee"
            )}
          </p>
          {null === displayPrice ? (
            <p data-testid="price-updating" style={{ fontSize: 15, fontWeight: 500, color: "#6b7280", margin: 0 }}>
              {priceUpdatingText(translate, langCode)}
            </p>
          ) : hasPromo && null !== regularPrice ? (
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ fontSize: 14, color: "#9ca3af", textDecoration: "line-through" }}>
                {numberFormat(regularPrice, "price")}
              </span>
              <span style={{ fontSize: 15, fontWeight: 700, color: "#111827" }}>
                {numberFormat(displayPrice, "price")}
              </span>
            </div>
          ) : (
            <p style={{ fontSize: 15, fontWeight: 700, color: "#111827", margin: 0 }}>
              {numberFormat(displayPrice, "price")}
            </p>
          )}
          {pricing?.promotion && pricing?.showPromo && null !== displayPrice && (
            <button
              onClick={onShowConditions}
              style={{
                border: "none",
                background: "none",
                cursor: "pointer",
                color: "#4f46e5",
                fontSize: 13,
                fontWeight: 500,
                padding: 0,
                marginTop: 4,
              }}
              onMouseEnter={(e) => { e.currentTarget.style.textDecoration = "underline"; }}
              onMouseLeave={(e) => { e.currentTarget.style.textDecoration = "none"; }}
            >
              {translate("newDashboard.promotion")}
            </button>
          )}
        </div>
      )}

      <ButtonDS
        label={translate("newDashboard.redesign.paymentHistory")}
        buttonType="secondary"
        size="32"
        onClick={() => navigateToRoute("billing")}
      />
    </div>
  );
};

export default BillingCard;
